// Pays dans lesquels une organisation peut s'inscrire : ceux où Stripe ouvre
// un compte et verse depuis la Belgique (UE, Norvège, Liechtenstein,
// Royaume-Uni, Suisse, États-Unis, Canada ; l'Islande est refusée par Stripe).
// Mêmes listes que cloud-api/api/core/countries.py, vérifiées par un test.
export const EU_COUNTRY_CODES = [
  'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR',
  'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI',
  'SK',
];

export const NON_EU_COUNTRY_CODES = ['CA', 'CH', 'GB', 'LI', 'NO', 'US'];

export const ACCEPTED_COUNTRY_CODES = [...EU_COUNTRY_CODES, ...NON_EU_COUNTRY_CODES];

// Pays sans l'euro : les inscriptions y restent vendues en euros.
export const NON_EURO_COUNTRY_CODES = [
  'CA', 'CH', 'CZ', 'DK', 'GB', 'HU', 'LI', 'NO', 'PL', 'RO', 'SE', 'US',
];

// Les pays nommés dans la langue de l'écran, triés sur ce nom.
/** Préfixe du numéro de TVA : la Grèce est GR comme pays, EL pour la TVA. */
export function vatPrefix(country: string): string {
  return country === 'GR' ? 'EL' : country;
}

export function isEuCountry(country: string): boolean {
  return EU_COUNTRY_CODES.includes(country);
}

export function countryOptions(locale: string): { code: string; name: string }[] {
  const names = new Intl.DisplayNames([locale], { type: 'region' });
  return ACCEPTED_COUNTRY_CODES
    .map((code) => ({ code, name: names.of(code) ?? code }))
    .sort((a, b) => a.name.localeCompare(b.name, locale));
}
